var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "teas-modify-password-div" }, [
    !_vm.step
      ? _c(
          "div",
          { staticClass: "teas-modify-password-page" },
          [
            _c("div", { staticClass: "page-title" }, [
              _vm._v(_vm._s(_vm.title || "")),
            ]),
            _c("div", { staticClass: "page-notice" }, [
              _vm._v(_vm._s(_vm.notice || "")),
            ]),
            _c("van-field", {
              staticClass: "input-content-item",
              attrs: {
                type: "password",
                clearable: "true",
                placeholder: "请输入新密码",
              },
              model: {
                value: _vm.newPwd,
                callback: function ($$v) {
                  _vm.newPwd = $$v
                },
                expression: "newPwd",
              },
            }),
            _vm.alterResult.length > 0
              ? _c("div", { staticClass: "error-content" }, [
                  _c("span", { staticClass: "iconfont icon-tixingshixin" }),
                  _vm._v(" " + _vm._s(_vm.alterResult || "") + " "),
                ])
              : _vm._e(),
            _c("van-field", {
              staticClass: "input-content-item",
              attrs: {
                type: "password",
                clearable: "true",
                placeholder: "请再次输入新密码",
              },
              model: {
                value: _vm.confirmPwd,
                callback: function ($$v) {
                  _vm.confirmPwd = $$v
                },
                expression: "confirmPwd",
              },
            }),
            _c(
              "van-button",
              {
                staticClass: "teas-modify-password-btn",
                class: !(_vm.newPwd && _vm.newPwd === _vm.confirmPwd)
                  ? "disabled"
                  : "",
                attrs: {
                  disabled: !(_vm.newPwd && _vm.newPwd === _vm.confirmPwd),
                },
                on: { click: _vm.nextStep },
              },
              [_vm._v(" 确定 ")]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.step
      ? _c("div", { staticClass: "teas-modify-password-page" }, [
          _c("div", { staticClass: "success-img-content" }, [
            _c("img", {
              staticClass: "success-img",
              attrs: { src: _vm.successImg, alt: "" },
            }),
          ]),
          _c("div", { staticClass: "success-notice" }, [
            _vm._v("密码修改成功"),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }